import {store} from 'src/redux/store';

/** The ambient project scope, applied by offline reads as the server would. */
export const projectScopeId = (): number | undefined =>
  store.getState().projectScope.scope?.id;

// Mirrors the backend ApplyProjectScope: under a scope, that project's own rows
// are visible alongside the instance-wide (null projectId) ones.
export const inProjectScope = (
  projectId: number | null | undefined,
  scopeId: number
): boolean => projectId === scopeId || projectId == null;
